import { render, staticRenderFns } from "./MailTemplatePopup.vue?vue&type=template&id=bc13e328&scoped=true"
import script from "./MailTemplatePopup.vue?vue&type=script&lang=js"
export * from "./MailTemplatePopup.vue?vue&type=script&lang=js"
import style0 from "./MailTemplatePopup.vue?vue&type=style&index=0&id=bc13e328&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc13e328",
  null
  
)

export default component.exports